import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Messages from './Messages';
import { useHitlAvailability } from '../hooks/useHitlAvailability';
import { SupportOrigin, SupportRequests } from '../components/SupportRequests';
import { useAuth } from 'react-oidc-context';

/** One staff worklist; distinct message and human-takeover authority. */
export default function SupportInbox() {
  const availability = useHitlAvailability();
  const auth = useAuth();
  const subject = auth.isAuthenticated ? auth.user?.profile.sub ?? '' : '';
  const token = auth.isAuthenticated ? auth.user?.access_token ?? '' : '';
  const [params] = useSearchParams();
  return <Messages heading="Support inbox"
    supportQueue={<SupportRequests subject={subject} token={token} enabled={availability.available} pending={availability.pending}
      failed={availability.error} retry={availability.retry} />}
    supportContext={<SupportOrigin subject={subject} token={token} threadId={params.get('conversationId')} canOpenSession={availability.available} />} />;
}
